var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import { FormSettingsContext, addComponent, createStateSnapshot, } from "./utils";
import copy from "fast-copy";
export var LayoutButtons = function (_a) {
    var parentId = _a.parentId, component = _a.component, isLayout = _a.isLayout;
    var _b = useContext(FormSettingsContext), settings = _b.settings, editedSettings = _b.editedSettings;
    var uuidv4 = require("uuid").v4;
    var hasComponents = function () {
        if (!component)
            return false;
        return (Array.isArray(component.components) && component.components.length > 0);
    };
    // Add new layout
    var requestAddComponent = function (e) {
        e.stopPropagation();
        if (!component.id) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var addState = __assign(__assign({}, settings), { selected: component.id, target: component.id, type: component.type, component: component.components, parentId: parentId, currentComponent: component, isNew: true });
        var after = createStateSnapshot(addState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "ADD_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, addState), { undoStack: saveUndo }));
    };
    var requestPasteComponent = function (e) {
        e.stopPropagation();
        if (!component.id) {
            return;
        }
        var before = createStateSnapshot(copy(settings));
        var newC = addComponent(Object.values(settings.newLayout || []), component.id, settings.clipBoard);
        var pasteState = __assign(__assign({}, settings), { clipBoard: "", newLayout: { layout: newC[0] } });
        var after = createStateSnapshot(pasteState);
        // SAVE_STATE
        var redoState = __assign(__assign({}, settings), { target: uuidv4(), label: "PASTE_COMPONENT", states: { before: before, after: after } });
        var saveUndo = copy(settings.undoStack);
        saveUndo.push(redoState);
        editedSettings(__assign(__assign({}, pasteState), { undoStack: saveUndo }));
    };
    return (_jsx(_Fragment, { children: !hasComponents() && isLayout && (_jsxs("div", __assign({ className: "flex flex-row" }, { children: [_jsxs("button", __assign({ className: "flex items-center justify-center flex-auto px-4 py-2 text-gray-700 bg-transparent hover:text-gray-900 hover:bg-transparent", onClick: function (e) {
                        requestAddComponent(e);
                    } }, { children: [_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "w-8 h-8", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", "stroke-width": "2" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M12 4v16m8-8H4" }) })), "Ajouter un composant pour ", component.type] })), settings.clipBoard !== "" && (_jsxs("button", __assign({ className: "flex items-center justify-center flex-auto px-4 py-2 text-green-700 bg-transparent hover:text-green-900 hover:bg-transparent", onClick: function (e) {
                        requestPasteComponent(e);
                    } }, { children: [_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", className: "w-8 h-8", viewBox: "0 0 20 20", fill: "currentColor" }, { children: [_jsx("path", { d: "M8 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z" }), _jsx("path", { d: "M6 3a2 2 0 00-2 2v11a2 2 0 002 2h8a2 2 0 002-2V5a2 2 0 00-2-2 3 3 0 01-3 3H9a3 3 0 01-3-3z" })] })), "Coller un composant"] })))] }))) }));
};
